import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { SessionStorageService } from './session-storage.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { RequestParams } from '../models/request-params';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService implements OnDestroy {
  private baseUrl: string = environment.apiUrl;
  private authToken: string;
  private authSubscription: Subscription;
  public companyContextSubscription: Subscription;
  public companyContext: string;

  constructor(
    private http: HttpClient,
    private SessionStorageService: SessionStorageService,
    private router: Router,
  ) {
    this.authSubscription = SessionStorageService.authTokenChange.subscribe((authToken) => {
      this.authToken = authToken;
    });
    this.companyContextSubscription = SessionStorageService.companyChange.subscribe( company => {
      this.companyContext = company;
    })
   }

  public getWithUrl(url: string, requestParams?: RequestParams): Promise<any> {
    const params: string = this.createQueryArguments(requestParams);
    let headers = new HttpHeaders();

    headers.append('Access-Control-Allow-Origin', '*')

    return this.http.get(url + params, { headers: headers } )
      .toPromise()
      .catch(error => this.handleError(error));
  }

  public get(endpoint: string, requestParams?: RequestParams): Promise<any> {
    const params: string = this.createQueryArguments(requestParams);

    return this.http.get(this.baseUrl + endpoint + params, { headers: this.createOptions() })
      .toPromise()
      .catch(error => this.handleError(error));
  }

  public post(endpoint: string, body: any, contentType?: string, accept?: string, token?: string): Promise<any> {

    return this.http.post(this.baseUrl + endpoint, body, { headers: this.createOptions(contentType) })
      .toPromise()
      .catch(error => this.handleError(error));
  }

  public postPDF(endpoint: string, body: any, contentType?: string, accept?: string, token?: string): Promise<any> {
    const headers = new HttpHeaders({'Content-Type':'application/json', 'Accept': 'application/pdf'});
    const options = { headers: headers, responseType: 'blob' as 'blob'};

    return this.http.post(this.baseUrl + endpoint, body, options)
      .toPromise()
      .catch(error => this.handleError(error));
  }

  public put(endpoint: string, body?: any, contentType?: string): Promise<any> {
    return this.http.put(this.baseUrl + endpoint, body, { headers: this.createOptions(contentType) })
      .toPromise()
      .catch(error => this.handleError(error));
  }

  public delete(endpoint: string, id?: string): Promise<any> {
    return this.http.delete(this.baseUrl + endpoint, { headers: this.createOptions() })
      .toPromise()
      .catch(error => this.handleError(error));
  }

  private createQueryArguments(requestParams: RequestParams): string {
    if (requestParams) {
      const queryList: Array<string> = [];

      if (requestParams.params) {
        requestParams.params.forEach((value, key) => {
          queryList.push(`${key}=${value}`);
        });
      }

      if (requestParams.includes) {
        requestParams.includes.forEach(include => {
          queryList.push(`includes=${include}`);
        });
      }

      return '?' + queryList.join('&');
    }

    return '';
  }

  private createOptions(contentType?: string, accept?: string, token?: string): HttpHeaders {
    //console.log("createOptions");
    console.log("createOptions most recent 3");
    console.log("accept", accept);

    // immutable
    let headers = new HttpHeaders();

    // add content type
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded'); // legacy

    // add accept
    headers = headers.set('Accept', accept || '*/*');

    // add token
    const authToken = this.authToken || token;
    if (authToken) {
      headers = headers.set('Authorization', authToken);
    }

    // add company
    if (this.companyContext) {
      headers = headers.set('X-Company', this.companyContext)
    }

    return headers;
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error);
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }
}
